import React from 'react';
import { FormattedMessage } from 'react-intl';

import HotkeySectionLineItem from './line-item';

import { messages as printPackingSlipMessages, hotkey as printPackingSlipHotkey } from '../advanced-hotkeys/print-packing-slip';
import { messages as printPickListMessages, hotkey as printPickListHotkey } from '../advanced-hotkeys/print-pick-list';
import { messages as printOrderSummaryMessages, hotkey as printOrderSummaryHotkey } from '../advanced-hotkeys/print-order-summary';

const PrintingHotkeys = () => {
  return (
    <>
      <HotkeySectionLineItem hotkey={printPackingSlipHotkey} name={<FormattedMessage {...printPackingSlipMessages.name} />} />
      <HotkeySectionLineItem hotkey={printPickListHotkey} name={<FormattedMessage {...printPickListMessages.name} />} />
      <HotkeySectionLineItem hotkey={printOrderSummaryHotkey} name={<FormattedMessage {...printOrderSummaryMessages.name} />} />
    </>
  );
};

export default PrintingHotkeys;
